import { useAuth } from "@clerk/react";
import { createContext, useContext, type ReactNode } from "react";

export type SessionState = "config-missing" | "loading" | "signed-out" | "signed-in";

export interface SessionContextValue {
  getToken(): Promise<string | null>;
  sessionId: string | null;
  userId: string | null;
  state: SessionState;
}

const SessionContext = createContext<SessionContextValue>({
  getToken: async () => null,
  sessionId: null,
  userId: null,
  state: "config-missing",
});

export function MissingSessionProvider({ children }: { children: ReactNode }) {
  return (
    <SessionContext.Provider value={{ getToken: async () => null, sessionId: null, userId: null, state: "config-missing" }}>
      {children}
    </SessionContext.Provider>
  );
}

export function ClerkSessionProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const state: SessionState = !auth.isLoaded
    ? "loading"
    : auth.isSignedIn
      ? "signed-in"
      : "signed-out";
  return (
    <SessionContext.Provider value={{ getToken: auth.getToken, sessionId: auth.sessionId ?? null, userId: auth.userId ?? null, state }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession(): SessionContextValue {
  return useContext(SessionContext);
}
